/**
 * Canonical auth storage for PatrolPuffin web.
 *
 * Single shared instance of `@puffin-core/auth-token-storage` so that
 * refresh deduplication and expiry event subscriptions coordinate across
 * every consumer.
 *
 * EAA-001: Created to replace direct StorageService access for auth tokens.
 *
 * @module core/api/auth/authStorage
 */

import { createAuthTokenStorage } from '@puffin-core/auth-token-storage';
import { StorageService } from '@puffin-core/storage';

import { flagLastReadStore } from '../../featureFlags/flagLastReadStore';

/**
 * Canonical patrol-web auth storage instance (localStorage, namespace `pt-auth`). Signing out also clears the app's
 * last good feature-flag read (UAT-BLOCKERS D1 item 11), on every path that ends the session.
 */
export const authStorage = createAuthTokenStorage('pt-auth', {
  storage: StorageService.getInstance(),
  clearOnSignOut: [flagLastReadStore.clear],
});

/** Endpoint the refresh coordinator POSTs to when exchanging refresh tokens. */
export const REFRESH_ENDPOINT = '/api/v1/auth/tenant/refresh';
